import React from 'react';

export type PrismicHTMLParserProps = {
    children: string[] | string | null;
    className?: string;
};

export const PrismicHTMLParser = ({ children, className, ...props }: PrismicHTMLParserProps) => {
    const htmlStrings = Array.isArray(children) ? children : [children];
    return (
        <>
            {htmlStrings.map((htmlString: string, i: number) => {
                if (!htmlString) {
                    return;
                }
                return (
                    htmlString && (
                        <div
                            className={className}
                            key={i}
                            dangerouslySetInnerHTML={{ __html: htmlString }}
                            {...props}
                        />
                    )
                );
            })}
        </>
    );
};
